import React, {createContext, useReducer, useContext, useMemo} from "react";
import { getAccountLocale } from "./helper";
import { getMapGeo, storeMapGeo } from "./sharedUtils";

const INITIAL_STATE = {
  account: null,
  initedData: {},
  regions: [],
  currentGeo: getMapGeo()
}

export const AccountContext = createContext({...INITIAL_STATE});

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_ACCOUNT":
      return {...state, account: action.payload || {}}
    case "SET_INIT_DATA":
      return {...state, initedData: action.payload || {}}
    case "SET_CURRENT_GEO":
      storeMapGeo({...action.payload});
      return {...state, currentGeo: action.payload || {}}
    case "SET_REGIONS":
      return {...state, regions: action.payload || {}}
    default:
      {
        return state;
      }      
  }
}


export const AppProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
  const setAccount = (data) => dispatch({ type: "SET_ACCOUNT", payload: data });
  const setInitedData = (data) => dispatch({ type: "SET_INIT_DATA", payload: data });
  const setCurrentGeo = (data) => dispatch({ type: "SET_CURRENT_GEO", payload: data });
  const setRegions = (data) => dispatch({ type: "SET_REGIONS", payload: data });

  const { account, initedData = {}, regions = [], currentGeo = null } = state
  const getLocale = (key) => {
    return getAccountLocale(key, account);
  };
  const contextValue = useMemo(() => ({
    state,
    account,
    initedData,
    currentGeo,
    regions,
    getLocale: getLocale,
    dispatch,
    setAccount,
    setInitedData,
    setRegions,
    setCurrentGeo
  }), [state, dispatch]);
  
  return (
    <AccountContext.Provider value={contextValue}>{children}</AccountContext.Provider>
  )
}

export const useAppContext = () => useContext(AccountContext);
